import React from "react";

const Rules = () => {
  return (
    <>
      <h2 className="article">Правила въезда в Турцию</h2>
      <p className="location_text">
        Виза для граждан России, СНГ и стран Евросоюза НЕ НУЖНА – ставится штамп
        по прилету.
      </p>
      <p className="location_text">
        Уточняйте правила по страховке, актуальные для вашей страны вылета. Для
        Украины необходима страховка, покрывающая ковид, на даты вашей поездки
        (ее могут спросить на паспортном контроле).
      </p>
      <p className="location_text">
        Перед вылетом в Турцию вам необходимо заранее заполнить следующую форму:⁣ 
        <a href="https://register.health.gov.tr/">
          https://register.health.gov.tr/
        </a>
        <br />
        Для заполнения формы вам понадобится информация об адресе проживания:
        <br />
        Город: Muğla
        <br /> Район: Marmaris
        <br /> Адрес: Ciftlik Ilgin Sk. 23
        <br /> Телефонный номер: +902524857201
      </p>
      <p className="location_text">
        Также вам необходимо иметь с собой ПЦР-тест на ковид с отрицательным
        результатом, сданным не раньше, чем за 72 часа до прибытия в Турцию.
      </p>
      <p className="location_text">
        Подтвержденная вакцинация пока не является обязательным требованием для
        въезда в Турцию.
      </p>
      <p className="location_text">
        Пожалуйста, свяжитесь с нами, перед покупкой билетов на самолет, чтобы
        мы могли организовать для вас и других участников совместный трансфер до
        отеля.
      </p>
    </>
  );
};

export default Rules;
